<div *ngIf="showHeader" class="flex align-items-center justify-content-between cursor-pointer" pStyleClass="@next"
  enterFromClass="hidden" enterActiveClass="scalein" leaveToClass="hidden" leaveActiveClass="fadeout"
  [hideOnOutsideClick]="true">
  <div class="flex align-items-center justify-content-center">
    <div class="h-2rem w-2rem bg-primary text-white border-round flex align-items-center justify-content-center">
      <i class="fa fa-rotate-left"></i></div>
    <div class="ml-3">
      <h4 class="text-base mb-0 line-height-1 font-bold">{{'TRANSACTION.SALES_RETURN' | translate}}</h4>
      <p class="mb-0 text-xs text-600" *ngIf="!loading && salesReturnData$ | async">
        {{(salesReturnData$ | async)?.length | number}} {{'TRANSACTION.SALES_RETURN_GENE' | translate}}</p>
        <p-skeleton *ngIf="loading" width="7rem" height="0.9rem" styleClass="mt-1"></p-skeleton>
    </div>
  </div>
  <i class="fa fa-circle-chevron-down text-primary"></i>
</div>

<div [ngClass]="showHeader ? 'hidden mt-2':''">
  <!-- Content -->
  <app-data-grid [columnData]="salesReturnData$" [columns]="salesReturnTablecolumns$" [selectable]="selectallsalesReturnData"
    (emitValue)="handleEvent($event)" (emitSelectValue)="handleSelectAll($event)" tableClasses="shadow-2 p-0 my-3"
    [headerClasses]="'surface-100 text-xs text-600 white-space-nowrap'" (onAction)="onActionEvent($event)"
    [EmptyState]="emptyStateComponent$" [paginator]="false" [gridName]="'sales-return-list'">
  </app-data-grid>
  <!-- Content -->
</div>


<!-- Void Invoice Modal -->
<p-dialog [(visible)]="showSalesReturnVoid" [resizable]="false" appendTo="body" [modal]="true"
  [breakpoints]="{'767px': '100vw'}" [style]="{width: '630px'}" styleClass="no-header-modal">

  <ng-template pTemplate="header" styleClass="hidden"></ng-template>
  <ng-template pTemplate="content" styleClass="p-0">

    <!-- Content -->
    <form [formGroup]="voidSalesReturnForm">
      <div class="relative text-center p-4">

        <div class="fa fa-times text-xl opacity-50 absolute right-0 top-0 mt-3 mr-3 md:mt-4 md:mr-4 cursor-pointer"
          (click)="showSalesReturnVoid = false"></div>

        <img width="160" class="block mx-auto" src="/assets/img/void-invoice-img.svg" alt="Image" />

        <h4 class="text-base md:text-lg my-3 font-bold">{{'SALES_RETURN.SALES_DEL_CONFI'| translate}} <br>
          {{salesReturnDetails.number_prefix}} ?</h4>
        <p class="text-600 md:w-26rem mx-auto mb-0">{{'SALES_RETURN.SALES_DEL_INFO'| translate}}</p>

      </div>
      <!-- Content -->

      <!-- Content -->
      <div class="surface-100 p-4">
        <label class="font-medium text-700 text-xs mb-2 block uppercase">{{'INVOICE.REASON'| translate}}</label>
        <textarea pInputTextarea formControlName="void_reason" class="text-sm w-full h-5rem"></textarea>
        <app-error-msg *ngIf="VoidReasonFormControl.touched && VoidReasonFormControl.invalid"
          [errors]="VoidReasonFormControl.errors" [fieldLabel]="'SALES_RETURN.MSG.REASON_REQUIRED' | translate">
        </app-error-msg>
      </div>
      <!-- Content -->

      <!-- Modal Footer -->
      <div class="flex align-items-center justify-content-between px-4 py-3 border-top-1 border-300">
        <button pButton pRipple type="button" [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate"
          class="p-button-primary p-button-text text-sm" (click)="showSalesReturnVoid = false">
        </button>
        <button pButton pRipple type="button" [label]="'SALES_RETURN.VOID_LABEL' | translate" class="p-button-danger text-sm" [loading]="btnLoading"
          (click)="deleteSalesReturn(voidSalesReturnForm)">
        </button>
      </div>
      <!-- Modal Footer -->
    </form>

  </ng-template>

</p-dialog>
<!-- Void Invoice Modal -->


